import { useRouter as useNextRouter } from 'next/navigation';

const useRouterNext = () => {
  const { push: nextPush, ...rest } = useNextRouter();

  const customPush = ({
    pathname,
    query,
    scrollEnabled = false,
  }: {
    pathname: string;
    query?: Record<string, any>;
    scrollEnabled?: boolean;
  }) => {
    const generateQuery = new URLSearchParams(query).toString();
    {
      query
        ? nextPush(`${pathname}?${generateQuery}`, { scroll: scrollEnabled })
        : nextPush(`${pathname}`);
    }
  };

  return { ...rest, push: customPush };
};

export default useRouterNext;
